module.exports = __webpack_public_path__ + "img/checkvert_off.ab902737.gif";